import Header from "../components/header";
import PageTitle from "../components/page-title";
import PageNavigator from "../components/page-navigator";
import InputModule from "../components/input-module";
import { useState,useEffect } from "react";
import { openSiteAdder } from "../functions/openInput";
import ExpandedSchedule from "../components/expanded-schedule";
import { fetchScheduledPosts } from "../functions/fetchScheduledPosts";
import Holder from "../components/holder";
import CustomPostModule from "../components/custom-post-module";
import { openCustomPostModule } from "../functions/openCustomPostModule";

function SchedulePage(){

    const [inputOpen,setInputOpen] = useState(false);
    const [fullyLoaded, changeFullyLoaded] = useState(false);
    const [scheduledPosts,setScheduledPosts] = useState(null);    

    const handleClick = () => {
        openSiteAdder(setInputOpen,inputOpen);
    }
        const [customPostModuleOpen,setCustomPostModuleOpen] = useState(false);

    const handleClick2 = () =>{
        openCustomPostModule(setCustomPostModuleOpen,customPostModuleOpen)
    }


    useEffect(() => {
        const waitForData = async() => {
        await fetchScheduledPosts(setScheduledPosts);
        changeFullyLoaded(true);
        }
        waitForData();
      }, []);


    return <>
    <Header CTA='Add site' functionForButton={handleClick} CTA2="Create post" functionForButton2={handleClick2}></Header>
    <Holder 
    left={<PageNavigator numberSelected={2}/>}
    right={<>
    <PageTitle text='Your one stop shop for content marketing publishing schedule.' heading='Your schedule'></PageTitle>
    <ExpandedSchedule scheduledPosts={scheduledPosts} fullyLoaded={fullyLoaded}></ExpandedSchedule></>}
    />
    <InputModule functionForButton={handleClick} display={inputOpen ? 'flex' : 'none'}/>
    <CustomPostModule display={customPostModuleOpen ? 'flex' : 'none'} functionForButton={handleClick2} />
    </>
}
    
export default SchedulePage;